import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { portalApi, setPortalToken } from "@/lib/portalApi";
import { BrandMark } from "@/components/BrandMark";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { getErrorMessage } from "@/lib/errors";

export function PortalFrame({ children }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#ECF4F7] px-4 dark:bg-slate-950">
      <div className="w-full max-w-md rounded-2xl border border-border bg-card px-8 py-10 shadow-xl">
        <div className="mb-6 flex justify-center"><BrandMark variant="light" /></div>
        {children}
      </div>
    </div>
  );
}

/** Where vendors and clients sign in to see their own orders, bills and projects. */
export default function PortalLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { const { data } = await portalApi.post("/portal/login", form); setPortalToken(data.access_token); navigate("/portal"); }
    catch (err) { setError(getErrorMessage(err)); } finally { setBusy(false); }
  };
  return (
    <PortalFrame>
      <h2 className="text-center text-2xl font-bold tracking-tight">Partner portal</h2>
      <p className="mb-6 mt-1 text-center text-sm text-muted-foreground">For our vendors and clients</p>
      <form onSubmit={submit} className="space-y-4" data-testid="portal-login-form">
        <div><Label htmlFor="p-email">Email</Label><Input id="p-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1.5" data-testid="portal-email" /></div>
        <div><Label htmlFor="p-pass">Password</Label><Input id="p-pass" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-1.5" data-testid="portal-password" /></div>
        {error && <p className="text-xs text-red-600" data-testid="portal-login-error">{error}</p>}
        <Button type="submit" disabled={busy} className="w-full" data-testid="portal-login-submit">{busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in</Button>
      </form>
      <p className="mt-6 text-center text-xs text-muted-foreground">Got an invitation link? Open it to choose your password.</p>
    </PortalFrame>
  );
}
